import { UserModel } from "../user/user.model";

export class UserLoginModel {
    token: string;
    user : UserModel;
    result : number;
}

export class ResetPasswordModel{
    email:string;
}